<template>
  <card
    class="website-menus"
    :class="{loading, 'empty-list': !loading && !sortedMenus.length, removeCardStyle}"
    id="website-menus"
  >
    <div class='items-wrapper'>
      <div class="d-flex justify-content-between">
        <h4>
          Websitemenu's
        </h4>

        <button class="btn btn-light add-menu" @click="addItem">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
          </svg>

          Menu toevoegen
        </button>
      </div>

      <div v-if="!loading && !sortedMenus.length"
        class="d-flex justify-content-center align-items-center empty-state"
        key="empty"
      >
        <EmptyStatePlaceholder
          title="U heeft geen websitemenu's"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
          </svg>
        </EmptyStatePlaceholder>
      </div>
      <div v-else-if="!loading" class="disable-ske" id="menu-items-wrapper" ref="menus" key="not-loading">
        <MenuItem v-for="(item, index) in sortedMenus" :key="item.name + index + item.path + item.uid"
          class="not-loading-item drag-handle"
          
          @click.native="editMenu(index)"
          @delete="deleteMenu(index)"

          :data-origionalposition="index"
          v-bind="item"
        />
      </div>
      <div v-else key="loading">
        <MenuItem v-for="(item, index) in placeholder" :key="item.name + index"
          v-bind="item"

          :forced-ske="true"
        />
      </div>
    </div>
  </card>
</template>

<script>

import MenuItem from "./MenuItem.vue"
import EmptyStatePlaceholder from "../../../layout/EmptyStatePlaceholder.vue"

import Sortable from "sortablejs"

const obj = {
  name: "Asht thas sah tehsoah",
  path: "/asht-wrd-drwrd",
}
const placeholder = [
  obj, obj, obj,
]

export default {
  components: {
    MenuItem,
    EmptyStatePlaceholder,
  },
  props: {
    websiteUid: {
      type: String,
      required: false,
    },
    removeCardStyle: Boolean,
  },
  async created() {
    await this.loadMenus()
  },
  data() {
    return {
      menus: [],
      loading: false,
      placeholder,
    }
  },
  methods: {
    mountSortable() {
      this.destroySortable()
      this.sortable = new Sortable(this.$refs["menus"], {
        handle: ".drag-handle",
        draggable: ".drag-handle",
        animation: 100,
        sort: true,
        filter: ".ignore-element",
        delay: 70,

        onUpdate: () => {
          this.$nextTick(async () => {
            const items = Array.from(this.$refs["menus"].children)
            const originalIndexes = items.map(item => item.dataset.origionalposition)

            const menus = this.menus.slice()
            originalIndexes.forEach((index, newPosition) => {
              menus[index].position = newPosition
            })
            menus.sort((a, b) => a.position - b.position)
            console.log(menus, menus.map(item => {
              return !item.uid ? {
                name: item.name,
                path: item.path,
                position: item.position,
              } : {
                category: item.uid,
                position: item.position,
              }
            }))

            this.loading = true
            await this.axios.put(`/api/websites/${this.websiteUid}`, {
              menu_items: menus.map(item => {
                return !item.uid ? {
                  name: item.name,
                  path: item.path,
                  position: item.position,
                } : {
                  category: item.uid,
                  position: item.position,
                }
              })
            })
            this.loadMenus()
          })
        },
      })
    },
    destroySortable() {
      if (this.sortable) {
        this.sortable.destroy()
        this.sortable = null
      }
    },
    editMenu(index) {
      this.$pushModal({
        modal: "EditWebsiteMenu",
        toBind: {
          callback: this.loadMenus,
          websiteUid: this.websiteUid,
          menus: this.menus,
          index,
        },
      })
    },
    async loadMenus() {
      this.loading = true
      
      const data = (await this.axios.get(`/api/websites/${this.websiteUid}`)).data
      data.menu_items.sort((a, b) => a.position - b.position)
      console.log(data.menu_items)
      this.menus = data.menu_items

      this.loading = false
    },
    async deleteMenu(index) {
      const menus = [...this.menus]
      menus.splice(index, 1)

      await this.$handlePromise(
        this.axios.put(`/api/websites/${this.websiteUid}`, {
          menu_items: menus.map((item, index) => {
            return item.category ? {
              category: item.uid,
            } : {
              name: item.name,
              path: item.path,
            }
          }),
        })
      )

      this.$success("Menu-item verwijderd!")
      this.loadMenus()
    },
    addItem() {
      this.$pushModal({
        modal: "EditWebsiteMenu",
        toBind: {
          callback: this.loadMenus,
          websiteUid: this.websiteUid,
          menus: this.menus,
        },
      })
    },
  },
  computed: {
    sortedMenus() {
      const arr = this.menus
      return arr.map((m, index) => arr.find(item => item.position === index)).filter(item => item)
    },
  },
  watch: {
    loading(val) {
      if (val) {
        this.destroySortable()
      } else {
        this.$nextTick(() => requestAnimationFrame(() => this.mountSortable()))
      }
    },
  },
}

</script>

<style scoped>

.website-menus, .items-wrapper {
  min-height: 100%;
}

.empty-state {
  margin-top: 225px;
}

.removeCardStyle {
  border: none !important;
}

h4 {
  margin: 0;
  margin-bottom: 10px;
}

svg {
  color: #9A9A9A;
  transform: translateY(-1px);
}

.main {
  font-size: 0.9375em;
}

.info {
  color: #9A9A9A;
}

</style>
